import {
  addEventParam,
  INinjaEvent,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import { useGlobalLoginContext, useProfileStore, KissanEventType, useEventZStore } from '@ninjacart/nc-nk-store';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useHeaderEvents = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const fields = useGlobalLoginContext(['openLoginSheet','previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;
  const userProfile = useProfileStore((state) => state.userProfile);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const hasUserLoggedIn = userProfile?.access_token ? true : false;
  const setMicTabRefreshCount = useEventZStore((state) => state.setMicTabRefreshCount);
  const handleSearch = (value: boolean) => {
    if (!value) {
      setMicTabRefreshCount(0)
    }
    router.push({
      pathname: `/search`,
      query: {
        openSpeechToTextBottomSheet: value,
      },
    });
    const homeSearchclickEvent: INinjaEvent = {
      name: KissanEventType.HOME_SEARCH_CLICK,
      screenDetails: { screen: 'home header page' },
    };
    enqueue(homeSearchclickEvent);
  };

  const handleWeatherPage = () => {
    const weatherClickEvent: INinjaEvent = {
      name: KissanEventType.FEED_WEATHER_BUTTON_CLICK,
      screenDetails: { screen: 'home header page' },
    };
    enqueue(weatherClickEvent);
    router.push('/weatherDetail');
  };

  const handleProfileIconClick = (eventName: KissanEventType, screenName: string) => {
    const profileClickEvent: INinjaEvent = {
      name: eventName,
      screenDetails: { screen: screenName },
      eventParams: [addEventParam('userName', userProfile?.user?.name ?? '')],
    };
    enqueue(profileClickEvent);
  };

  const handleProfileClick = () => {
    handleProfileIconClick(KissanEventType.USER_PROFILE_CLICKED, 'home header page');
    router.push('/profile');
  };

  const handleCreatePost = () => {
    if (!hasUserLoggedIn) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('Feed-Create page');
      setNavigationParams({
        name: '',
        routeName: { name: 'createQuestion/index' },
        description: `${t('page.pleaseLoginCreatePost')}`,
        screenName: 'Feed-Create page',
      });
    } else {
      router.push('/createQuestion');
    }
  };

  const handleLogin = () => {
    if (!hasUserLoggedIn) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('Feed page');
      setNavigationParams({
        name: '',
        routeName: {
          name: '(tabs)',
        },
        description: `${t('page.goToLogin')}`,
        screenName: 'Feed page',
      });
      return;
    }
  };

  return {
    handleLogin,
    handleCreatePost,
    handleSearch,
    handleWeatherPage,
    handleProfileClick,
    handleProfileIconClick,
  };
};
